import type { ReactElement } from 'react';
import { GroupHeadingProps } from 'react-select';
import styled, { useTheme } from 'styled-components';
import { Flex } from '../../../containers/Flex/Flex.component';
import { Text } from '../../../typography';
import {
  ISelectProps,
  ILegacySelectOptionData,
  LegacySelectComponentProps,
  LegacySelectOptionGroup,
} from '../Select.types';

type SelectGroupHeadingProps = LegacySelectComponentProps<
  GroupHeadingProps<ILegacySelectOptionData, boolean, LegacySelectOptionGroup>
>;

const StyledFlex = styled(Flex)<{ variant: NonNullable<ISelectProps['variant']> }>`
  border-bottom: 1px solid ${({ theme, variant }) => theme.select.variants[variant]?.menu.group.borderColor};
`;

export const SelectGroupHeading = ({ children, selectProps: { variant } }: SelectGroupHeadingProps): ReactElement => {
  const theme = useTheme();

  return (
    <StyledFlex justifyContent={'space-between'} alignItems={'center'} px={2} py={1} variant={variant}>
      <Text color={theme.select.variants[variant]?.menu.group.textColor} weight={700}>
        {children}
      </Text>
    </StyledFlex>
  );
};

SelectGroupHeading.displayName = 'SelectGroupHeading';
